// Helper di formattazione date/ore SEMPRE in fuso orario Europe/Rome.
// Indipendentemente dal fuso locale del dispositivo, l'utente vede l'orario italiano.

const ROME_TZ = 'Europe/Rome';
const LOCALE = 'it-IT';

const toDateObj = (input) => {
  if (!input) return null;
  if (input instanceof Date) return input;
  const d = new Date(input);
  return isNaN(d.getTime()) ? null : d;
};

export const formatRomeDate = (input) => {
  const d = toDateObj(input);
  if (!d) return '-';
  return new Intl.DateTimeFormat(LOCALE, {
    timeZone: ROME_TZ,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(d);
};

export const formatRomeTime = (input) => {
  const d = toDateObj(input);
  if (!d) return '-';
  return new Intl.DateTimeFormat(LOCALE, {
    timeZone: ROME_TZ,
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
};

export const formatRomeDateTime = (input) => {
  const d = toDateObj(input);
  if (!d) return '-';
  return new Intl.DateTimeFormat(LOCALE, {
    timeZone: ROME_TZ,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
};

export const formatRomeMonthYear = (input) => {
  const d = toDateObj(input);
  if (!d) return '-';
  return new Intl.DateTimeFormat(LOCALE, {
    timeZone: ROME_TZ,
    month: 'long',
    year: 'numeric',
  }).format(d);
};

/**
 * Formattazione personalizzata in fuso Europe/Rome.
 * Accetta le stesse opzioni di Intl.DateTimeFormatOptions ma forza timeZone.
 */
export const formatRome = (input, options = {}) => {
  const d = toDateObj(input);
  if (!d) return '-';
  return new Intl.DateTimeFormat(LOCALE, {
    timeZone: ROME_TZ,
    ...options,
  }).format(d);
};
